/**
 * Capitalizes a string (makes the first letter Uppercase and the rest of the string lowerCase)
 *
 * @param {string} formula A string containing a dirty formula
 * @returns {string} A string containing cleaned formula that can be processed
 */
export const capitalizeString = (value: string): string => {
  // Gets the first letter.
  // Capitalizes it.
  // Concatenates it with the rest of the string in lowerCase.
  // Deletes blank spaces at the end and at the start
  if (typeof value === 'string') {
    return (value.charAt(0).toUpperCase() + value.toLocaleLowerCase().slice(1)).trim();
  } else {
    console.warn(`capitalizeString() can't be applied to a non-string parameter`);
    return value;
  }
};
